<template>
    <div>
        <b-alert show>
            <strong>CND - Certidão Conjunta de Débitos PJ</strong>
        </b-alert>
        <b-row class="pb-2">
            <b-col>
                <p class="mb-0">
                    Data Atualização:
                    <strong>{{
                        fornecedor.cndAtualizacao
                            ? $moment(fornecedor.cndAtualizacao).format(
                                  'DD/MM/YYYY HH:mm:ss'
                              )
                            : ''
                    }}</strong>
                </p>
                <p class="mb-0">
                    Status:
                    <app-status
                        :status="
                            fornecedor.cndSituacao
                                ? fornecedor.cndSituacao.toUpperCase()
                                : 'NÃO ATUALIZADO'
                        "
                    ></app-status>
                </p>
                <p class="mb-0">
                    Data Emissão:
                    <strong>{{
                        fornecedor.cndDataEmissao
                            ? $moment(fornecedor.cndDataEmissao).format(
                                  'DD/MM/YYYY HH:mm:ss'
                              )
                            : ''
                    }}</strong>
                </p>
                <p class="mb-0">
                    Validade:
                    <strong>{{
                        fornecedor.cndValidade
                            ? $moment(fornecedor.cndValidade).format(
                                  'DD/MM/YYYY'
                              )
                            : ''
                    }}</strong>
                </p>
                <p>
                    Certificado:
                    <strong>{{ fornecedor.cndCodigo }}</strong>
                </p>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        fornecedor: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {},

    computed: {},

    created() {},

    components: {}
}
</script>
